/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WorkerEquipmentModelResponse } from './worker-equipment-model-response';
import { WorkerStatuses } from './worker-statuses';


export interface SearchWorkersResponse { 
    id: string;
    displayName: string;
    avgTenMinutesHashRate: number;
    avgHourHashRate: number;
    avgDailyHashRate: number;
    refusedShards: number;
    status: WorkerStatuses;
    groupId?: string | null;
    lastHashDate?: string | null;
    upTime?: string | null;
    equipmentModel?: WorkerEquipmentModelResponse;
}



